import React, {Component} from 'react';
import {List, ListItem} from 'material-ui/List';
import {NavLink} from 'react-router-dom';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';
import Book from 'material-ui-icons/Book';
import Event from 'material-ui-icons/Event';
import Headset from 'material-ui-icons/Headset';
import Scanner from 'material-ui-icons/Scanner';
import CreditCard from 'material-ui-icons/CreditCard';
import {FormattedMessage} from 'react-intl';
import AddEventInRoutesListContainer from '../containers/addEventInRoutesList.container';
import './routes.css';
import ScannerDetails from './scannerDetails'
import {PlaylistPlay} from "material-ui-icons";
import features from '../utils/features';

class RoutesList extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>
                <List className="nav-menu">
                    <AddEventInRoutesListContainer/>
                    <div className="menudivider">
                        <Divider />
                    </div>
                    <ListItem
                        key={1}
                        leftAvatar={<Avatar icon={<Event />} backgroundColor = 'rgba(0, 0, 0, 0)'/>}
                        containerElement={<NavLink to="/" exact />}
                    >
                        <FormattedMessage
                            id = "sidemenu.myEventsText"
                        />
                    </ListItem>
                    <ListItem
                        key={2}
                        leftAvatar={<Avatar icon={<Book/>} backgroundColor = 'rgba(0, 0, 0, 0)'/>}
                        containerElement={<NavLink to="/templates" exact />}
                    >
                        <FormattedMessage
                            id = "sidemenu.templatesText"
                        />
                    </ListItem>
                    <ListItem
                        key={3}
                        leftAvatar={<Avatar icon={<PlaylistPlay/>} backgroundColor = 'rgba(0, 0, 0, 0)'/>}
                        containerElement={<NavLink to="/playlist" exact />}
                    >
                        <FormattedMessage
                            id = "sidemenu.recommendationsText"
                        />
                    </ListItem>
                    <ListItem
                        key={4}
                        leftAvatar={<Avatar icon={<Headset/>} backgroundColor = 'rgba(0, 0, 0, 0)'/>}
                        containerElement={<NavLink to="/userInfo" exact />}
                    >
                        <FormattedMessage
                            id = "sidemenu.userInfoText"
                        />
                    </ListItem>
                    {features.showAccountTab &&
                        <div>
                            <ListItem
                                key={5}
                                leftAvatar={<Avatar icon={<CreditCard/>} backgroundColor = 'rgba(0, 0, 0, 0)'/>}
                                containerElement={<NavLink to="/account" exact />}
                            >
                                <FormattedMessage
                                    id = "sidemenu.accountText"
                                />
                            </ListItem>
                        </div>
                    }
                    <ListItem
                        key={6}
                        leftAvatar={<Avatar icon={<Scanner/>} backgroundColor = 'rgba(0, 0, 0, 0)'/>}
                        containerElement={<NavLink to="/scanner" exact />}
                    >
                        <FormattedMessage
                            id = "sidemenu.scannerText"
                        />
                    </ListItem>
                </List>
                <div>
                    <ScannerDetails/>
                </div>
            </div>
        );
    }
}


export default RoutesList;



// WEBPACK FOOTER //
// ./src/routers/routesList.js